export default "__VITE_ASSET__eG6uRyLm__"